import { render } from "./guidepage.vue?vue&type=template&id=4a4edf6f"
import script from "./guidepage.vue?vue&type=script&lang=js"
export * from "./guidepage.vue?vue&type=script&lang=js"

import "./guidepage.vue?vue&type=style&index=0&id=4a4edf6f&lang=stylus"

import exportComponent from "G:\\all_project\\all\\hengda-star-region-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__